<div class="inspector-root">

  <!-- ── Body ───────────────────────────────────────────────── -->
  <div class="inspector-content">

    <!-- ── Left: Device Screen ────────────────────────────── -->
    <div class="screen-panel" [style.flex]="'0 0 ' + panelWidth + '%'">
      <div class="screen-panel-header">
        <div class="sph-title">
          <i class="fa fa-mobile-alt"></i>
          <span>{{ deviceCapabilities?.['appium:deviceName'] || 'Device Screen' }}</span>
        </div>
        <div class="sph-actions">
          <button class="sph-btn" (click)="refreshAll()" [disabled]="isLoading" title="Refresh">
            <i class="fa fa-sync-alt" [class.fa-spin]="isLoading"></i>
          </button>
          <button class="sph-btn" (click)="toggleAutoRefresh()" [class.active]="autoRefresh" title="Auto Refresh">
            <i class="fa fa-clock"></i>
            Auto: {{ autoRefresh ? 'ON' : 'OFF' }}
          </button>
          @if (activeTab === 'image-recorder') {
          <button class="sph-btn select-region-btn" (click)="toggleImageSelectMode()" [class.active]="imageSelectMode"
            title="Select Region">
            <i [class]="imageSelectMode ? 'fa fa-times' : 'fa fa-crop-alt'"></i>
            {{ imageSelectMode ? 'Cancel' : 'Select Region' }}
          </button>
          }
        </div>
      </div>

      <div class="screen-body">
        <div class="phone-frame-area">

          <!-- Positioning context for the wrapper image + canvas. Both children
         are siblings, each independently centered via inset:0 + margin:auto,
         exactly like the reference markup. -->
          <div class="phone-stage">

            <img class="mobile-wrapper" [style.aspect-ratio]="canvasAspect" src="assets/Wrapper/Mobile_wrapper.png"
              alt="" />

            <canvas #screenshotCanvas class="screen" (click)="onScreenClick($event)" (mousemove)="onScreenHover($event)"
              (mouseleave)="clearHoverHighlight()">
            </canvas>

            <canvas #overlayCanvas class="overlay-canvas" [class.select-mode]="imageSelectMode"
              (mousedown)="onSelectionStart($event)" (mousemove)="onSelectionMove($event)"
              (mouseup)="onSelectionEnd($event)" (mouseleave)="onSelectionCancel()">
            </canvas>

            @if (hoveredCoords) {
            <div class="coord-badge">
              <i class="fa fa-crosshairs"></i>
              x: {{ hoveredCoords.x }}, y: {{ hoveredCoords.y }}
              <span class="coord-hint">click to tap</span>
            </div>
            }

            @if (hoveredElement) {
            <div class="screen-overlay">
              <div class="hover-tooltip" [style.left.px]="tooltipX" [style.top.px]="tooltipY">
                <strong>{{ hoveredElement.class }}</strong>
                @if (hoveredElement.text) {
                <div class="tt-text">{{ hoveredElement.text }}</div>
                }
                <div class="tt-id">{{ hoveredElement.resourceId }}</div>
              </div>
            </div>
            }

            @if (isLoading) {
            <div class="center-state dark stage-overlay">
              <div class="spinner"></div>
              <p>Loading device screen…</p>
            </div>
            }

            @if (!isLoading && !screenshot) {
            <div class="center-state dark stage-overlay">
              <div class="state-icon error-icon">
                <i class="fa fa-exclamation-triangle"></i>
              </div>
              <p class="state-msg">{{ errorMessage || 'Failed to load screenshot' }}</p>
              <button class="retry-btn" (click)="refreshScreenshot()">
                <i class="fa fa-redo"></i> Retry
              </button>
            </div>
            }

          </div><!-- /phone-stage -->

        </div><!-- /phone-frame-area -->

        <div class="side-actions">
          <button class="sa-btn" (click)="navigateBack()" [disabled]="isLoading" title="Back">
            <i class="fa fa-arrow-left"></i>
          </button>
          <button class="sa-btn" (click)="navigateHome()" [disabled]="isLoading" title="Home">
            <i class="fa fa-home"></i>
          </button>
          <button class="sa-btn" (click)="navigateRecents()" [disabled]="isLoading" title="Recent Apps">
            <i class="fa fa-clone"></i>
          </button>

          <div class="sa-divider"></div>

          <button class="sa-btn" (click)="performAction('tap')" [disabled]="!selectedElement || isPerformingAction"
            title="Tap">
            <i class="fa fa-hand-pointer"></i>
          </button>
          <button class="sa-btn" (click)="performAction('longPress')"
            [disabled]="!selectedElement || isPerformingAction" title="Long Press">
            <i class="fa fa-hand"></i>
          </button>
          <button class="sa-btn" (click)="performAction('clear')" [disabled]="!selectedElement || isPerformingAction"
            title="Clear Field">
            <i class="fa fa-eraser"></i>
          </button>
          <button class="sa-btn" (click)="performAction('getAttribute')"
            [disabled]="!selectedElement || isPerformingAction" title="Get Attributes">
            <i class="fa fa-info-circle"></i>
          </button>
        </div>

      </div>
    </div>

    <!-- RESIZER -->
    <div class="resizer" (mousedown)="startResize($event)"></div>

    <!-- ── Right Section: Tabs + Content ─────────────────── -->
    <div class="right-section">

      <!-- Tab Bar -->
      <div class="tab-bar">
        <div class="tab-bar-tabs">
          <button class="tab-btn" [class.active]="activeTab === 'source'" (click)="setTab('source')">Source</button>
          <button class="tab-btn" [class.active]="activeTab === 'recorder'"
            (click)="setTab('recorder')">Recorder</button>
          <button class="tab-btn" [class.active]="activeTab === 'image-recorder'"
            (click)="setTab('image-recorder')">Image Recorder</button>
        </div>

        <div class="tab-bar-end">
          <button class="tb-end-btn" (click)="endSession()">
            <i class="fa fa-power-off"></i>
            End Session
          </button>
        </div>
      </div>

      <!-- Source Tab -->
      @if (activeTab === 'source') {
      <div class="source-layout">

        <!-- App Source Panel -->
        <div class="app-source-panel">
          <div class="ap-header">
            <div class="ap-title">
              <i class="fa fa-file-alt"></i>
              App Source
            </div>
            <div class="ap-actions">
              <button class="ap-icon-btn" title="Copy Source"
                (click)="copyToClipboard(pageSourceXML?.documentElement?.outerHTML || '')">
                <i class="fa fa-copy"></i>
              </button>
              <button class="ap-icon-btn" title="Download Source">
                <i class="fa fa-download"></i>
              </button>
            </div>
          </div>

          <div class="ap-toolbar">
            <button class="ap-tool-btn" (click)="expandAll()" title="Expand All">
              <i class="fa fa-expand-alt"></i>
            </button>
            <button class="ap-tool-btn" (click)="collapseAll()" title="Collapse All">
              <i class="fa fa-compress-alt"></i>
            </button>
            <div class="ap-search">
              <i class="fa fa-search ap-search-icon"></i>
              <input type="text" class="ap-search-input" placeholder="Search Source" [(ngModel)]="searchQuery"
                (input)="filterTree()" />
              @if (searchQuery) {
              <button class="ap-search-clear" (click)="searchQuery = ''; filterTree()">
                <i class="fa fa-times"></i>
              </button>
              }
            </div>
            <span class="ap-count-badge">{{ elementTree?.length || 0 }}</span>
          </div>

          <div class="ap-body" #sourceContainer>
            @if (!isLoading && elementTree && elementTree.length > 0) {
            <div class="tree-view">
              @for (node of elementTree; track node) {
              <app-tree-node [node]="node" [level]="0" [selectedNode]="selectedElement" [expandAllFlag]="expandAllFlag"
                (nodeClick)="onElementSelect($event)" (nodeHover)="onElementHover($event)">
              </app-tree-node>
              }
            </div>
            }
            @if (isLoading) {
            <div class="center-state">
              <div class="spinner"></div>
              <p>Loading element tree…</p>
            </div>
            }
            @if (!isLoading && (!elementTree || elementTree.length === 0)) {
            <div class="center-state">
              <div class="state-icon"><i class="fa fa-sitemap"></i></div>
              <p class="state-msg">No elements found</p>
              <p class="state-hint">Take a screenshot to populate the tree</p>
            </div>
            }
          </div>
        </div>

        <!-- Selected Element Panel -->
        <div class="selected-panel">
          <div class="ap-header">
            <div class="ap-title">
              <i class="fa fa-tag"></i>
              Selected Element
            </div>
            <div class="ap-actions">
              @if (selectedElement) {
              <button class="ap-icon-btn" title="Copy Element" (click)="copyToClipboard(selectedElement?.xpath || '')">
                <i class="fa fa-copy"></i>
              </button>
              <button class="ap-icon-btn" title="Download">
                <i class="fa fa-download"></i>
              </button>
              }
            </div>
          </div>

          <!-- Send Keys Bar -->
          <div class="send-keys-bar">
            <button class="skb-btn" title="Clear" (click)="performAction('clear')"
              [disabled]="!selectedElement || isPerformingAction">
              <i class="fa fa-chevron-left"></i>
            </button>
            <input type="text" class="skb-input" placeholder="Enter Keys to Send" [(ngModel)]="textToSend"
              (keypress)="onEnterSendKeys($event)" />
            <button class="skb-btn primary" title="Send Keys" (click)="performAction('sendKeys')"
              [disabled]="!selectedElement || isPerformingAction || !textToSend">
              <i class="fa fa-paper-plane"></i>
            </button>
            <button class="skb-btn" title="Clear Text" (click)="textToSend = ''">
              <i class="fa fa-times"></i>
            </button>
            <button class="skb-btn" title="Time Delay">
              <i class="fa fa-clock"></i>
            </button>
          </div>

          <div class="selected-body">
            @if (!selectedElement) {
            <div class="empty-inspector">
              <div class="empty-icon"><i class="fa fa-mouse-pointer"></i></div>
              <p class="empty-title">No Element Selected</p>
              <p class="empty-hint">Click an element in the tree or tap on the device screen</p>
            </div>
            }

            @if (selectedElement) {

            <!-- Action Result Toast -->
            @if (lastActionResult) {
            <div class="action-toast" [class.success]="lastActionResult.success"
              [class.error]="!lastActionResult.success">
              <i [class]="lastActionResult.success ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
              <span>{{ lastActionResult.message }}</span>
            </div>
            }

            <!-- Locator Table -->
            <div class="locator-table-wrap">
              <table class="locator-table">
                <thead>
                  <tr>
                    <th>Find By</th>
                    <th>Selector</th>
                  </tr>
                </thead>
                <tbody>
                  @for (locator of generatedLocators; track locator) {
                  <tr (click)="copyToClipboard(locator.value)" title="Click to copy">
                    <td class="lt-type">{{ locator.type }}</td>
                    <td class="lt-value">
                      <span class="lt-val-text">{{ locator.value }}</span>
                      <button class="lt-copy-btn" (click)="$event.stopPropagation(); copyToClipboard(locator.value)">
                        <i class="fa fa-copy"></i>
                      </button>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>

            <!-- Box Model -->
            @if (selectedElement.bounds) {
            <div class="box-model-section">
              <div class="bm-label">Box Model</div>
              <div class="bm-container">
                <div class="bm-top-val">{{ selectedElement.bounds.width }}</div>
                <div class="bm-row">
                  <div class="bm-left-val">{{ selectedElement.bounds.height }}</div>
                  <div class="bm-box">
                    <div class="bm-corner bm-tl">{{ selectedElement.bounds.left }}, {{ selectedElement.bounds.top }}
                    </div>
                    <div class="bm-corner bm-tr">{{ selectedElement.bounds.right }}, {{ selectedElement.bounds.top }}
                    </div>
                    <div class="bm-center">({{ selectedElement.bounds.centerX }}, {{ selectedElement.bounds.centerY }})
                    </div>
                    <div class="bm-corner bm-bl">{{ selectedElement.bounds.left }}, {{ selectedElement.bounds.bottom }}
                    </div>
                    <div class="bm-corner bm-br">{{ selectedElement.bounds.right }}, {{ selectedElement.bounds.bottom }}
                    </div>
                  </div>
                  <div class="bm-right-val">{{ selectedElement.bounds.height }}</div>
                </div>
                <div class="bm-bottom-val">{{ selectedElement.bounds.width }}</div>
              </div>
            </div>
            }

            <!-- Element Attributes -->
            <div class="attr-section">
              <div class="attr-section-title">Attributes</div>
              <table class="locator-table">
                <tbody>
                  @if (selectedElement.attributes?.class) {
                  <tr>
                    <td class="lt-type">class</td>
                    <td class="lt-value"><span class="lt-val-text">{{ selectedElement.attributes.class }}</span></td>
                  </tr>
                  }
                  @if (selectedElement.attributes?.text) {
                  <tr>
                    <td class="lt-type">text</td>
                    <td class="lt-value"><span class="lt-val-text highlight">{{ selectedElement.attributes.text
                        }}</span></td>
                  </tr>
                  }
                  @if (selectedElement.attributes?.['content-desc']) {
                  <tr>
                    <td class="lt-type">content-desc</td>
                    <td class="lt-value"><span class="lt-val-text">{{ selectedElement.attributes['content-desc']
                        }}</span></td>
                  </tr>
                  }
                  @if (selectedElement.attributes?.['resource-id']) {
                  <tr>
                    <td class="lt-type">resource-id</td>
                    <td class="lt-value"><span class="lt-val-text mono">{{ selectedElement.attributes['resource-id']
                        }}</span></td>
                  </tr>
                  }
                  <tr>
                    <td class="lt-type">clickable</td>
                    <td class="lt-value">
                      <span class="lt-val-text" [class.val-true]="selectedElement.attributes?.clickable === 'true'"
                        [class.val-false]="selectedElement.attributes?.clickable !== 'true'">
                        {{ selectedElement.attributes?.clickable || 'false' }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="lt-type">enabled</td>
                    <td class="lt-value">
                      <span class="lt-val-text" [class.val-true]="selectedElement.attributes?.enabled === 'true'"
                        [class.val-false]="selectedElement.attributes?.enabled !== 'true'">
                        {{ selectedElement.attributes?.enabled || 'false' }}
                      </span>
                    </td>
                  </tr>
                  @if (selectedElement.attributes?.bounds) {
                  <tr>
                    <td class="lt-type">bounds</td>
                    <td class="lt-value"><span class="lt-val-text mono">{{ selectedElement.attributes.bounds }}</span>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>

            }
          </div>
        </div>

      </div>
      }

      <!-- Recorder Tab -->
      @if (activeTab === 'recorder') {
      <div class="recorder-tab">
        <div class="rec-tab-header">
          <div class="rec-tab-title">
            <i class="fa fa-circle rec-dot-icon"></i>
            Recorded Actions
          </div>
          <div class="rec-tab-actions">
            <input type="text" class="ir-script-name-input" placeholder="Recording name" [(ngModel)]="elementScriptName"
              [disabled]="isPlayingAllElements" />

            <button class="rec-btn" [class.recording]="isRecording" (click)="toggleRecording()">
              <i [class]="isRecording ? 'fa fa-stop-circle' : 'fa fa-circle'"></i>
              {{ isRecording ? 'Stop Recording' : 'Record' }}
            </button>

            @if (recordedElementSteps.length > 0) {
            <button class="ir-play-all-btn" [class.playing]="isPlayingAllElements" (click)="playAllElementSteps()"
              [disabled]="recordedElementSteps.length === 0"
              [title]="isPlayingAllElements ? 'Stop Playback' : 'Play All Steps'">
              <i [class]="isPlayingAllElements ? 'fa fa-stop-circle' : 'fa fa-play-circle'"></i>
              {{ isPlayingAllElements ? 'Stop' : 'Play All' }}
            </button>

            <button class="ir-save-btn" (click)="saveElementRecording()"
              [disabled]="isSavingElementScript || isPlayingAllElements || recordedElementSteps.length === 0"
              title="Save Recording">
              <i [class]="isSavingElementScript ? 'fa fa-spinner fa-spin' : 'fa fa-save'"></i>
              {{ isSavingElementScript ? 'Saving...' : 'Save Recording' }}
            </button>

            <button class="ap-icon-btn" (click)="exportRecording()" title="Export">
              <i class="fa fa-download"></i>
            </button>
            <button class="ap-icon-btn danger" (click)="clearRecording()" title="Delete Whole Recording">
              <i class="fa fa-trash"></i>
            </button>
            }
          </div>
        </div>

        @if (isPlayingAllElements && elementExecutionStatus) {
        <div class="ir-execution-hud"
          style="background: #1e293b; padding: 12px; margin-bottom: 12px; border-radius: 6px; color: #fff; display: flex; align-items: center; justify-content: space-between; border-left: 4px solid #167FFC;">
          <div style="display: flex; align-items: center; gap: 12px;">
            @if (elementExecutionStatus === 'RUNNING') {
            <i class="fa fa-spinner fa-spin" style="color: #167FFC;"></i>
            }
            <span>
              <strong>Execution Status:</strong> {{ elementExecutionStatus }}
              ({{ currentElementExecutionStep }}/{{ totalElementExecutionSteps }} Steps)
            </span>
          </div>
          <button class="btn btn-sm btn-danger" (click)="stopElementScriptExecution()"
            style="background: #ef4444; border: none; padding: 4px 10px; border-radius: 4px; color: #fff; cursor: pointer;">
            <i class="fa fa-stop"></i> Stop
          </button>
        </div>
        }

        @if (elementScriptSaveResult) {
        <div class="action-toast" [class.success]="elementScriptSaveResult.success"
          [class.error]="!elementScriptSaveResult.success">
          <i [class]="elementScriptSaveResult.success ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
          <span>{{ elementScriptSaveResult.message }}</span>
        </div>
        }

        @if (isRecording) {
        <div class="ir-hint-bar">
          <i class="fa fa-mouse-pointer"></i>
          Recording — select an element on the screen or in the Source tree to add a step
        </div>
        }

        @if (recordedElementSteps.length === 0) {
        <div class="center-state">
          <div class="state-icon"><i class="fa fa-list-ol"></i></div>
          <p class="state-msg">No recorded steps</p>
          <p class="state-hint">Click Record, then select an element on screen to capture a step</p>
          <button class="ap-tool-btn" style="margin-top: 10px;" (click)="startInsertSystemAction(0)">
            <i class="fa fa-plus"></i> Add System Action
          </button>
        </div>
        }

        @if (recordedElementSteps.length > 0) {
        <div class="rec-actions-list" [class.ir-disabled-list]="isPlayingAllElements">

          <!-- Insert-at-top -->
          <div class="ir-step-divider">
            <div class="ir-add-step-wrap">
              <button class="ir-add-step-btn" (click)="toggleInsertMenu(-1)" [disabled]="isPlayingAllElements"
                title="Insert step here">
                <i class="fa fa-plus"></i>
              </button>
              @if (insertMenuIndex === -1) {
              <div class="ir-insert-menu">
                <button (click)="startInsertElementStep(0)"><i class="fa fa-mouse-pointer"></i> Select Element</button>
                <button (click)="startInsertSystemAction(0)"><i class="fa fa-microchip"></i> System Action</button>
              </div>
              }
            </div>
            <span class="ir-add-step-line"></span>
          </div>

          @for (step of recordedElementSteps; track trackByStepId($index, step); let idx = $index) {
          <div class="er-step-card" [class.playing]="isPlayingAllElements && currentElementExecutionStep === idx + 1">

            <div class="er-step-icon">
              <i [class]="'fa ' + getStepActionIcon(step.action)"></i>
            </div>

            <div class="er-step-body">
              <div class="er-step-header">
                <span class="er-step-index">#{{ step.step }}</span>
                <input class="ir-region-label" [(ngModel)]="step.element_name" [disabled]="isPlayingAllElements"
                  placeholder="Step name" />

                @if (isPlayingAllElements && elementExecutionStepResults[idx]?.status === 'SUCCESS') {
                <span class="er-status-badge success"><i class="fa fa-check-circle"></i> Passed</span>
                }
                @if (isPlayingAllElements && elementExecutionStepResults[idx]?.status === 'FAILED') {
                <span class="er-status-badge error" [title]="elementExecutionStepResults[idx]?.error || 'Step Failed'">
                  <i class="fa fa-times-circle"></i> Failed
                </span>
                }
                @if (!isPlayingAllElements && step.runStatus === 'RUNNING') {
                <span class="er-status-badge running"><i class="fa fa-spinner fa-spin"></i> Running</span>
                }
                @if (!isPlayingAllElements && step.runStatus === 'SUCCESS') {
                <span class="er-status-badge success"><i class="fa fa-check-circle"></i> Passed</span>
                }
                @if (!isPlayingAllElements && step.runStatus === 'FAILED') {
                <span class="er-status-badge error" [title]="step.runError || 'Step Failed'">
                  <i class="fa fa-times-circle"></i> Failed
                </span>
                }
              </div>

              <div class="er-step-meta">
                @if (step.selector_strategy) {
                <span class="ir-meta-chip"><i class="fa fa-crosshairs"></i> {{ step.selector_strategy }}</span>
                <span class="ir-meta-chip mono">{{ step.selector_value }}</span>
                }
                @if (step.action === 'keycode') {
                <span class="ir-meta-chip"><i class="fa fa-microchip"></i> keycode: {{ step.key_code }}</span>
                }
              </div>

              <div class="er-step-footer">
                <select class="ir-action-select" [(ngModel)]="step.action" [disabled]="isPlayingAllElements">
                  <option value="tap">Tap</option>
                  <option value="input">Input Text</option>
                  <option value="long_press">Long Press</option>
                  <option value="clear">Clear</option>
                  <option value="get_text">Get Text</option>
                  <option value="is_visible">Is Visible</option>
                </select>

                @if (step.action === 'input') {
                <input type="text" class="ir-input-value" placeholder="Text to send" [(ngModel)]="step.value"
                  [disabled]="isPlayingAllElements" />
                }

                <button class="ir-run-btn" (click)="runElementStep(step)"
                  [disabled]="isPlayingAllElements || step.runStatus === 'RUNNING'" title="Run this step">
                  <i class="fa fa-play"></i>
                </button>
                <button class="ir-del-btn" (click)="removeElementStep(step.id)" [disabled]="isPlayingAllElements"
                  title="Remove step">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Insert-between divider -->
          <div class="ir-step-divider">
            <div class="ir-add-step-wrap">
              <button class="ir-add-step-btn" (click)="toggleInsertMenu(idx)" [disabled]="isPlayingAllElements"
                title="Insert step here">
                <i class="fa fa-plus"></i>
              </button>
              @if (insertMenuIndex === idx) {
              <div class="ir-insert-menu">
                <button (click)="startInsertElementStep(idx + 1)"><i class="fa fa-mouse-pointer"></i> Select
                  Element</button>
                <button (click)="startInsertSystemAction(idx + 1)"><i class="fa fa-microchip"></i> System
                  Action</button>
              </div>
              }
            </div>
            <span class="ir-add-step-line"></span>
          </div>
          }
        </div>
        }
      </div>
      }

      <!-- Action Picker Modal -->
      @if (showActionPicker) {
      <div class="er-modal-backdrop" (click)="cancelActionPicker()">
        <div class="er-modal" (click)="$event.stopPropagation()">
          <div class="er-modal-header">
            <span><i class="fa fa-hand-pointer"></i> Configure Step</span>
            <button class="ap-icon-btn" (click)="cancelActionPicker()"><i style="margin:0;"
                class="fa fa-times"></i></button>
          </div>
          <div class="er-modal-body">
            <label class="er-field-label">Element</label>
            <div class="er-picked-element">
              <span class="er-tag-chip">{{ pendingPickerElement?.tag }}</span>
              @if (pendingPickerElement?.attributes?.text) {
              <span class="er-el-text">"{{ pendingPickerElement?.attributes?.text }}"</span>
              }
            </div>

            <label class="er-field-label">Step Name</label>
            <input type="text" class="er-modal-input" [(ngModel)]="pickerElementName"
              placeholder="e.g. Tap sign in button" />

            <label class="er-field-label">Action</label>
            <select class="er-modal-input" [(ngModel)]="pickerAction">
              <option value="tap">Tap</option>
              <option value="input">Input Text</option>
              <option value="long_press">Long Press</option>
              <option value="clear">Clear</option>
              <option value="get_text">Get Text</option>
              <option value="is_visible">Is Visible</option>
            </select>

            @if (pickerAction === 'input') {
            <label class="er-field-label">Text to Send</label>
            <input type="text" class="er-modal-input" [(ngModel)]="pickerValue" placeholder="Text value" />
            }
          </div>
          <div class="er-modal-footer">
            <button class="btn btn-sm btn-danger" (click)="cancelActionPicker()">Cancel</button>
            <button class="btn btn-sm btn-primary rec-btn" (click)="confirmActionPicker()">
              <i class="fa fa-check"></i> Add Step
            </button>
          </div>
        </div>
      </div>
      }

      <!-- System Action Modal -->
      @if (showSystemActionPicker) {
      <div class="er-modal-backdrop" (click)="cancelSystemAction()">
        <div class="er-modal" (click)="$event.stopPropagation()">
          <div class="er-modal-header">
            <span><i class="fa fa-microchip"></i> System Action</span>
            <button class="ap-icon-btn" (click)="cancelSystemAction()"><i class="fa fa-times"></i></button>
          </div>
          <div class="er-modal-body">
            <label class="er-field-label">Step Name</label>
            <input type="text" class="er-modal-input" [(ngModel)]="systemActionName"
              placeholder="e.g. Go to home screen" />

            <label class="er-field-label">Action</label>
            <select class="er-modal-input" [(ngModel)]="systemActionType">
              <option value="home">Home</option>
              <option value="back">Back</option>
              <option value="recents">Recent Apps</option>
              <option value="keycode">Custom Keycode</option>
            </select>

            @if (systemActionType === 'keycode') {
            <label class="er-field-label">Key Code</label>
            <input type="number" class="er-modal-input" [(ngModel)]="systemActionKeyCode" placeholder="e.g. 66" />
            }
          </div>
          <div class="er-modal-footer">
            <button class="btn btn-sm ap-tool-btn" (click)="cancelSystemAction()">Cancel</button>
            <button class="btn btn-sm rec-btn" (click)="confirmSystemAction()">
              <i class="fa fa-check"></i> Add Step
            </button>
          </div>
        </div>
      </div>
      }

      @if (activeTab === 'image-recorder') {
      <div class="image-recorder-tab">

        <div class="ir-header">
          <div class="ir-title">
            <i class="fa fa-camera"></i>
            Image Recorder
          </div>
          <div class="ir-actions">
            <input type="text" class="ir-script-name-input" placeholder="Script name" [(ngModel)]="imageScriptName"
              [disabled]="isPlayingAll" />
            <label class="ir-toggle-switch" [class.disabled]="isPlayingAll">
              <input type="checkbox" [checked]="imageSelectMode" (change)="toggleImageSelectMode()"
                [disabled]="isPlayingAll">
              <span class="ir-slider round"></span>
              <span class="ir-toggle-label">Select Region</span>
            </label>

            @if (imageRegions.length > 0) {
            <button class="ir-play-all-btn" [class.playing]="isPlayingAll" (click)="playAllImageRegions()"
              [disabled]="isPerformingAction" [title]="isPlayingAll ? 'Stop Playback' : 'Play All Regions'">
              <i [class]="isPlayingAll ? 'fa fa-stop-circle' : 'fa fa-play-circle'"></i>
              {{ isPlayingAll ? 'Stop' : 'Play All' }}
            </button>

            <button class="ir-save-btn" (click)="saveImageScript()" [disabled]="isSavingScript || isPlayingAll"
              title="Save Script">
              <i [class]="isSavingScript ? 'fa fa-spinner fa-spin' : 'fa fa-save'"></i>
              {{ isSavingScript ? 'Saving...' : 'Save Script' }}
            </button>

            <button class="ap-icon-btn danger" (click)="clearImageRegions()" title="Clear All"
              [disabled]="isPlayingAll">
              <i class="fa fa-trash"></i>
            </button>
            }
          </div>
        </div>

        @if (isPlayingAll && executionStatus) {
        <div class="ir-execution-hud"
          style="background: #1e293b; padding: 12px; margin-bottom: 12px; border-radius: 6px; color: #fff; display: flex; align-items: center; justify-content: space-between; border-left: 4px solid #167FFC;">
          <div style="display: flex; align-items: center; gap: 12px;">
            @if (executionStatus === 'RUNNING') {
            <i class="fa fa-spinner fa-spin" style="color: #167FFC;"></i>
            }
            @if (executionStatus === 'PAUSED') {
            <i class="fa fa-pause-circle" style="color: #eab308;"></i>
            }
            <span>
              <strong>Execution Status:</strong> {{ executionStatus }}
              ({{ currentExecutionStep }}/{{ totalExecutionSteps }} Steps)
            </span>
          </div>
          <div style="display: flex; gap: 8px;">
            @if (executionStatus === 'RUNNING') {
            <button class="btn btn-sm btn-warning" (click)="pauseScriptExecution()"
              style="background: #eab308; border: none; padding: 4px 10px; border-radius: 4px; color: #000; cursor: pointer;">
              <i class="fa fa-pause"></i> Pause
            </button>
            }
            @if (executionStatus === 'PAUSED') {
            <button class="btn btn-sm btn-success" (click)="resumeScriptExecution()"
              style="background: #22c55e; border: none; padding: 4px 10px; border-radius: 4px; color: #fff; cursor: pointer;">
              <i class="fa fa-play"></i> Resume
            </button>
            }
            <button class="btn btn-sm btn-danger" (click)="stopScriptExecution()"
              style="background: #ef4444; border: none; padding: 4px 10px; border-radius: 4px; color: #fff; cursor: pointer;">
              <i class="fa fa-stop"></i> Stop
            </button>
          </div>
        </div>
        }

        @if (scriptSaveResult) {
        <div class="action-toast" [class.success]="scriptSaveResult.success" [class.error]="!scriptSaveResult.success">
          <i [class]="scriptSaveResult.success ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
          <span>{{ scriptSaveResult.message }}</span>
        </div>
        }

        @if (imageSelectMode) {
        <div class="ir-hint-bar">
          <i class="fa fa-crop-alt"></i>
          Draw a rectangle on the device screen to capture a region
        </div>
        }

        @if (imageRegions.length === 0) {
        <div class="center-state">
          <div class="state-icon"><i class="fa fa-crop-alt"></i></div>
          <p class="state-msg">No regions captured</p>
          <p class="state-hint">Click "Select Region" then drag on the device screen</p>
        </div>
        }

        @if (imageRegions.length > 0) {
        <div class="ir-regions-list" [class.ir-disabled-list]="isPlayingAll">
          @for (region of imageRegions; track region.id; let idx = $index) {
          <div class="ir-region-card" [class.playing]="playingRegionId === region.id">

            <div class="ir-region-preview">
              <img [src]="region.dataUrl" [alt]="region.label" class="ir-region-img" />
              <div class="ir-region-coords-overlay">{{ region.x }}, {{ region.y }}</div>

              @if (isPlayingAll && executionStepResults[idx]?.status === 'SUCCESS') {
              <div class="ir-region-upload-overlay success" style="background: rgba(34, 197, 94, 0.75)"
                title="Step Passed">
                <i class="fa fa-check-circle" style="font-size: 24px;"></i>
              </div>
              }
              @if (isPlayingAll && executionStepResults[idx]?.status === 'FAILED') {
              <div class="ir-region-upload-overlay error" style="background: rgba(239, 68, 68, 0.75)"
                [title]="executionStepResults[idx]?.error || 'Step Failed'">
                <i class="fa fa-times-circle" style="font-size: 24px;"></i>
              </div>
              }

              <!-- NEW — single-step run status (only meaningful when not in a full playback run) -->
              @if (!isPlayingAll && region.runStatus === 'RUNNING') {
              <div class="ir-region-upload-overlay" style="background: rgba(22, 127, 252, 0.75)" title="Running">
                <i class="fa fa-spinner fa-spin" style="font-size: 24px;"></i>
              </div>
              }
              @if (!isPlayingAll && region.runStatus === 'SUCCESS') {
              <div class="ir-region-upload-overlay success" style="background: rgba(34, 197, 94, 0.75)"
                title="Step Passed">
                <i class="fa fa-check-circle" style="font-size: 24px;"></i>
              </div>
              }
              @if (!isPlayingAll && region.runStatus === 'FAILED') {
              <div class="ir-region-upload-overlay error" style="background: rgba(239, 68, 68, 0.75)"
                [title]="region.runError || 'Step Failed'">
                <i class="fa fa-times-circle" style="font-size: 24px;"></i>
              </div>
              }

              @if (region.isUploading) {
              <div class="ir-region-upload-overlay">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
              }
              @if (region.uploadError) {
              <div class="ir-region-upload-overlay error" [title]="region.uploadError">
                <i class="fa fa-exclamation-triangle"></i>
              </div>
              }
              @if (region.image_id && !region.isUploading && !region.uploadError && !isPlayingAll && !region.runStatus){
              <div class="ir-region-upload-overlay success" title="Uploaded">
                <i class="fa fa-check-circle"></i>
              </div>
              }
            </div>

            <div class="ir-region-info">
              <div class="ir-region-info-header">
                <input class="ir-region-label" [(ngModel)]="region.label" [disabled]="isPlayingAll" />
                <div class="ir-region-meta">
                  <span class="ir-meta-chip"><i class="fa fa-crosshairs"></i> x: {{ region.x }}</span>
                  <span class="ir-meta-chip"><i class="fa fa-crosshairs"></i> y: {{ region.y }}</span>
                  <span class="ir-meta-chip"><i class="fa fa-ruler-combined"></i> {{ region.width }} × {{ region.height
                    }}</span>
                  @if (isPlayingAll && executionStepResults[idx]?.confidence) {
                  <span class="ir-meta-chip" style="background: #0369a1; color: #fff;">
                    Match: {{ (executionStepResults[idx].confidence * 100).toFixed(0) }}%
                  </span>
                  }
                </div>
              </div>

              <div class="ir-region-footer">
                <select class="ir-action-select" [(ngModel)]="region.action" [disabled]="isPlayingAll">
                  <option value="img_tap" selected>Tap</option>
                  <option value="img_input">Image Input</option>
                  <option value="img_long_press">Image Long Press</option>
                  <option value="img_swipe">Image Swipe</option>
                  <option value="img_clear">Image Clear</option>
                  <option value="img_isvisible">Image IsVisible</option>
                </select>

                @if (region.action === 'img_input') {
                <input type="text" class="ir-input-value" placeholder="Text to send" [(ngModel)]="region.value"
                  [disabled]="isPlayingAll" />
                }

                <button class="ir-run-btn" (click)="performImageRegionAction(region)"
                  [disabled]="isPerformingAction || isPlayingAll" title="Execute Single Step Interactively">
                  <i class="fa fa-play"></i>
                </button>
                <button class="ir-del-btn" (click)="removeImageRegion(region.id)" [disabled]="isPlayingAll"
                  title="Remove">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- NEW — hover "+" divider to insert a step between this card and the next -->
          @if (idx < imageRegions.length - 1) { <div class="ir-step-divider">
            <button class="ir-add-step-btn" (click)="addStepAt(idx + 1)" [disabled]="isPlayingAll"
              title="Insert step here">
              <i class="fa fa-plus"></i>
            </button>
            <span class="ir-add-step-line"></span>
        </div>
        }
        }
      </div>
      }

    </div>
    }

  </div>

</div>

@if (showCloseSessionAlert) {
<div class="alert-overlay">
  <div class="alert-box">
    <div class="alert-icon">
      <div class="spinner-border text-warning" role="status"></div>
    </div>
    <div class="alert-content">
      <h5>Appium Inspector</h5>
      <p>Closing Appium Session...</p>
    </div>
  </div>
</div>
}

<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #alerttemplate1 let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="OkAndRouteToDevices()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #alerttemplate2 let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg + '\nDo you want to exit anyways?'| translate}}
    </p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"Yes" | translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="OKAndStay()">{{"No" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #alerttemplateStay let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="OKAndStay()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>